export function initMap(mapRoot) {
	const { lon, lat, zoom } = mapRoot.dataset;
	var map = L.map('map').setView([lat, lon], zoom);
	L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
		maxZoom: 19,
		attribution:
			'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
	}).addTo(map);
	var marker = L.marker([lat, lon]).addTo(map);
}
